import { withFormsy, propTypes } from "formsy-react";
import React from "react";
import { FormGroup, FormFeedback, Label, Input, FormText } from "reactstrap";
import { Spinner } from "../../Shared";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import { tourMessages } from "../../../_constants/tutorialmessages/ManualMessages";

export class TextInputComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultDay: "1",
      stepIndex: 0,
      steps: [
        {
          target: tourMessages.instructorTitle.target,
          content: (
            <div>
              <p>{tourMessages.instructorTitle.title}</p>
            </div>
          ),
          placement: "left",
          locale: { skip: "SKIP", close: "Next" }
        },
        tourMessages.default
      ]
    };
  }
  changeValue = event => {
    if (this.props.onChange) {
      this.props.onChange(event.target.value);
    }
    if (
      event.target.value === "" ||
      this.props.isValidValue(event.target.value) ||
      this.props.type !== "text"
    ) {
      this.props.setValue(
        event.currentTarget[
          this.props.type === "checkbox" ? "checked" : "value"
        ]
      );
    }
  };
  //================TOUR GUIDE SECTION========================//
  handleJoyrideCallback = data => {
    const { action, index, status, type } = data;

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
    } else if ([STATUS.CANCEL, STATUS.CANCEL].includes(status)) {
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      if ([STATUS.SKIPPED].includes(status)) {
        this.setState({ run: false });
      } else {
        this.props.setMainJoyRide();
      }
    }
  };
  render() {
    const errorMessage = this.props.getErrorMessage();
    const {
      validating,
      className,
      disabled,
      showRequired,
      showError,
      getValue,
      showLoader,
      name,
      size,
      onKeyUp,
      title,
      placeholder,
      isPristine,
      type,
      infoText,
      hasValue,
      isRequired,
      isSelectDropDown,
      subtitle,
      cursor,
      onLabelClick,
      joyRideRun
    } = this.props;
    const hasError =
      !isPristine() && (showError() || (isRequired() && !hasValue()));
    const { steps, stepIndex } = this.state;
    return (
      <div>
        <Joyride
          steps={steps}
          scrollToFirstStep
          showProgress
          showSkipButton
          styles={{
            options: {
              width: 300,
              height: 60,
              zIndex: 1000
            }
          }}
          callback={this.handleJoyrideCallback}
          run={joyRideRun}
          stepIndex={stepIndex}
        />
        <FormGroup className={className}>
          {title && (
            <Label className={isRequired() ? "required" : ""} htmlFor={name}>
              {title}
            </Label>
          )}
          {subtitle && (
            <label
              style={{
                color: "blue",
                fontStyle: "italic",
                fontSize: "10px",
                cursor: cursor ? "pointer" : null
              }}
              onClick={cursor ? onLabelClick : null}
            >
              {subtitle}
            </label>
          )}

          {!isSelectDropDown ? (
            <Input
              bsSize={size}
              invalid={hasError}
              type={type || "text"}
              value={getValue() || ""}
              disabled={validating ? true : false || disabled}
              onChange={this.changeValue}
              name={name}
              placeholder={placeholder}
              id={name}
              onKeyUp={onKeyUp}
              autoComplete="on"
              className={joyRideRun ? "joyride13" : " "}
            />
          ) : (
            <Input
              bsSize={size}
              invalid={hasError}
              type={type || "text"}
              value={getValue() || 1}
              defaultValue={1}
              disabled={validating ? true : false || disabled}
              onChange={this.changeValue}
              name={name}
              placeholder={placeholder}
              id={name}
              onKeyUp={onKeyUp}
              autoComplete="on"
            >
              <option key={1} value="1">
                Daily
              </option>
              <option key={7} value="7">
                Weekly
              </option>
              <option key={30} value="30">
                Monthly
              </option>
            </Input>
          )}

          {infoText ? <FormText>{infoText}</FormText> : ""}
          {hasError ? <FormFeedback>{errorMessage}</FormFeedback> : ""}
          {showRequired() ? <FormFeedback>Required</FormFeedback> : ""}
          {showLoader ? <Spinner /> : ""}
        </FormGroup>
      </div>
    );
  }
}

TextInputComponent.propTypes = {
  ...propTypes
};

const MyInput = withFormsy(TextInputComponent);

export { MyInput as TextInput };
